<div class="edit-seats-object">
    <div class="d-flex align-items-center mb-3 title-section" (click)="cancelEdit(true)">
        <i class="fa-light fa-arrow-left pointer-in" style="margin-right: 20px;"></i>
        <p class="m-0">Sección</p>
    </div>

    <div class="options-edit-section" [class.active]="activedEditing">

        <!-- ── Información principal ── -->
        <div class="section-edit">
            <div class="field-group">
                <label class="field-label">Nombre del grupo de butacas</label>
                <input class="field-input" type="text" placeholder="Nombre" [(ngModel)]="valueName" (change)="editName()" required>
            </div>
            <div class="check-row d-flex align-items-center justify-content-between">
                <p class="m-0">Mostrar nombre en el mapa</p>
                <mat-checkbox [(ngModel)]="visibilityNameSection" class="checkbox" color="primary"
                    (change)="changeVisibilityName()"></mat-checkbox>
            </div>
            <div class="field-group">
                <label class="field-label">Nivel</label>
                <select class="field-input" [(ngModel)]="level" (change)="editArea()" [compareWith]="compareLevels" required>
                    <option [ngValue]="undefined" disabled>Selecciona un nivel</option>
                    <option *ngFor="let nivel of levels" [ngValue]="nivel">{{ nivel.name || 'Nivel ' + nivel.id }}</option>
                </select>
            </div>
            <div class="stat-row">
                <p class="m-0">Total de asientos</p>
                <span class="stat-badge">{{sectionSeats.rows * sectionSeats.columns - invisibleSeats.length}}</span>
            </div>
            <div class="field-group">
                <label class="field-label">Color de butacas</label>
                <div class="field-color">
                    <input class="field-input field-input--hex" type="text" placeholder="#Hex" [(ngModel)]="seatColor" (input)="editSeatColor()">
                    <span class="field-color__swatch">
                        <input type="color" [(ngModel)]="seatColor" (input)="editSeatColor()">
                    </span>
                </div>
            </div>
            <div class="field-range">
                <div class="field-range__head">
                    <label class="field-label">Rotación de la sección</label>
                    <span class="field-range__value">
                        <input type="number" min="-180" max="180" step="1" [(ngModel)]="valueAngle" (input)="editRotation(valueAngle)">
                        <span class="field-range__unit">°</span>
                    </span>
                </div>
                <input type="range" min="-180" max="180" step="1" [(ngModel)]="valueAngle" (input)="editRotation(valueAngle)" class="slider-rotation">
            </div>
            <!-- ── Tipo de curvatura ── -->
            <div class="field-group">
                <label class="field-label">Tipo de curvatura</label>
                <div class="curvature-mode-toggle d-flex" style="gap:8px">
                    <button type="button" class="btn-mode" [class.active]="curvatureMode==='parabolic'"
                        (click)="setCurvatureMode('parabolic')">Parabólica</button>
                    <button type="button" class="btn-mode" [class.active]="curvatureMode==='radial'"
                        (click)="setCurvatureMode('radial')">Radial (concéntrica)</button>
                    <button type="button" class="btn-mode" [class.active]="curvatureMode==='elliptical'"
                        (click)="setCurvatureMode('elliptical')">Elíptica</button>
                </div>
            </div>

            <!-- Curvatura parabólica clásica (por sección) -->
            <div class="field-range" *ngIf="curvatureMode==='parabolic'">
                <div class="field-range__head">
                    <label class="field-label">Curvatura de la sección</label>
                    <span class="field-range__value">
                        <input type="number" min="-100" max="100" step="0.5" [(ngModel)]="valueCurvature" (input)="editCurve()">
                    </span>
                </div>
                <input type="range" min="-100" max="100" step="0.5" [(ngModel)]="valueCurvature" (input)="editCurve()" class="slider-rotation">
            </div>

            <!-- Curvatura radial/elíptica: centro externo propio + radio (+ achatamiento/rotación
                 solo en modo elíptico). -->
            <ng-container *ngIf="curvatureMode==='radial' || curvatureMode==='elliptical'">
                <div class="field-group">
                    <label class="field-label">Centro de curvatura</label>
                    <div class="pivot-controls d-flex align-items-center" style="gap:8px">
                        <button type="button" class="btn-pivot" [class.active]="showCurvatureCenter"
                            (click)="toggleCurvatureCenter()">
                            <i class="fa-light" [class.fa-crosshairs]="!showCurvatureCenter"
                                [class.fa-check]="showCurvatureCenter"></i>
                            {{ showCurvatureCenter ? 'Colocando…' : 'Colocar en el mapa' }}
                        </button>
                    </div>
                    <p class="info-hint" *ngIf="showCurvatureCenter">
                        Haz clic en el mapa donde quieras el centro (o arrastra el punto ✛ para
                        ajustarlo). La sección se recolocará como arco alrededor de él.
                    </p>
                </div>
                <div class="field-range">
                    <div class="field-range__head">
                        <label class="field-label">Radio (distancia al centro)</label>
                        <span class="field-range__value">
                            <input type="number" min="0" step="10" [(ngModel)]="baseRadius" (change)="setBaseRadius()"
                                placeholder="auto">
                        </span>
                    </div>
                </div>
                <ng-container *ngIf="curvatureMode==='elliptical'">
                    <div class="field-range">
                        <div class="field-range__head">
                            <label class="field-label">Achatamiento (eje Y / eje X)</label>
                            <span class="field-range__value">
                                <input type="number" min="0.1" max="1" step="0.05" [(ngModel)]="ellipseAspect" (change)="setEllipseAspect()">
                            </span>
                        </div>
                        <input type="range" min="0.1" max="1" step="0.05" [(ngModel)]="ellipseAspect" (input)="setEllipseAspect()" class="slider-rotation">
                        <p class="info-hint">1 = círculo perfecto. Cuanto menor, más ovalada la pista.</p>
                    </div>
                    <div class="field-range">
                        <div class="field-range__head">
                            <label class="field-label">Rotación del óvalo</label>
                            <span class="field-range__value">
                                <input type="number" min="-180" max="180" step="1" [(ngModel)]="ellipseRotation" (change)="setEllipseRotation()">
                                <span class="field-range__unit">°</span>
                            </span>
                        </div>
                        <input type="range" min="-180" max="180" step="1" [(ngModel)]="ellipseRotation" (input)="setEllipseRotation()" class="slider-rotation">
                    </div>
                </ng-container>
                <div class="field-group">
                    <label class="checkbox-inline">
                        <input type="checkbox" [checked]="radialInvert" (change)="toggleRadialInvert()">
                        Invertir fila más cercana al centro
                    </label>
                </div>
            </ng-container>
            <div class="field-range">
                <div class="field-range__head">
                    <label class="field-label">Espacio entre columnas</label>
                    <span class="field-range__value">
                        <input type="number" min="0.6" max="3" step="0.1" [(ngModel)]="columnSpacing" (input)="editSpacing()">
                    </span>
                </div>
                <input type="range" min="0.6" max="3" step="0.1" [(ngModel)]="columnSpacing" (input)="editSpacing()" class="slider-rotation">
            </div>
            <div class="field-range">
                <div class="field-range__head">
                    <label class="field-label">Espacio entre filas</label>
                    <span class="field-range__value">
                        <input type="number" min="0.6" max="3" step="0.1" [(ngModel)]="rowSpacing" (input)="editSpacing()">
                    </span>
                </div>
                <input type="range" min="0.6" max="3" step="0.1" [(ngModel)]="rowSpacing" (input)="editSpacing()" class="slider-rotation">
            </div>
            <div class="check-row d-flex align-items-center justify-content-between">
                <p class="m-0">Personalizar espacio por fila</p>
                <mat-checkbox [ngModel]="rowSpacingPerRow" class="checkbox" color="primary"
                    (ngModelChange)="toggleRowSpacingPerRow($event)"></mat-checkbox>
            </div>
            <ng-container *ngIf="rowSpacingPerRow">
                <div class="field-group" *ngIf="rowsForSpacing.length; else noRowsForSpacing">
                    <label class="field-label">Fila</label>
                    <select class="field-input" [(ngModel)]="selectedRowSpacingPosition" (change)="onSelectRowForSpacing()">
                        <option *ngFor="let r of rowsForSpacing" [ngValue]="r.position">Fila {{ r.label }}</option>
                    </select>
                </div>
                <ng-template #noRowsForSpacing>
                    <p class="info-hint">Esta sección no tiene filas.</p>
                </ng-template>
                <div class="field-range" *ngIf="selectedRowSpacingPosition != null">
                    <div class="field-range__head">
                        <label class="field-label">Espacio entre butacas de esta fila</label>
                        <span class="field-range__value">
                            <input type="number" min="0.6" max="3" step="0.1" [(ngModel)]="selectedColumnSpacingValue" (input)="editRowColumnSpacing()">
                        </span>
                    </div>
                    <input type="range" min="0.6" max="3" step="0.1" [(ngModel)]="selectedColumnSpacingValue" (input)="editRowColumnSpacing()" class="slider-rotation">
                    <button type="button" class="btn-reset-spacing" (click)="resetRowColumnSpacing()">
                        <i class="fa-light fa-rotate-left"></i> Restablecer al global
                    </button>
                </div>
                <div class="field-range" *ngIf="selectedRowSpacingPosition != null">
                    <div class="field-range__head">
                        <label class="field-label">Alinear fila horizontalmente</label>
                        <span class="field-range__value">
                            <input type="number" step="0.1" [(ngModel)]="selectedRowOffsetXValue" (input)="editRowOffsetX()">
                        </span>
                    </div>
                    <input type="range" min="-20" max="20" step="0.1" [(ngModel)]="selectedRowOffsetXValue" (input)="editRowOffsetX()" class="slider-rotation">
                    <p class="info-hint">Mueve solo esta fila (y sus números) a izquierda/derecha, útil para realinearla tras cambiar su espacio entre butacas.</p>
                    <button type="button" class="btn-reset-spacing" (click)="resetRowOffsetX()">
                        <i class="fa-light fa-rotate-left"></i> Restablecer alineación
                    </button>
                </div>
                <div class="field-range" *ngIf="selectedRowSpacingPosition != null && selectedRowSpacingPosition > 1">
                    <div class="field-range__head">
                        <label class="field-label">Espacio respecto a la fila anterior</label>
                        <span class="field-range__value">
                            <input type="number" min="0.6" max="3" step="0.1" [(ngModel)]="selectedRowSpacingValue" (input)="editRowSpacing()">
                        </span>
                    </div>
                    <input type="range" min="0.6" max="3" step="0.1" [(ngModel)]="selectedRowSpacingValue" (input)="editRowSpacing()" class="slider-rotation">
                    <button type="button" class="btn-reset-spacing" (click)="resetRowSpacing()">
                        <i class="fa-light fa-rotate-left"></i> Restablecer al global
                    </button>
                </div>
                <p class="info-hint" *ngIf="selectedRowSpacingPosition === 1">
                    La primera fila no tiene fila anterior con la que espaciarse.
                </p>
            </ng-container>
        </div>

        <!-- ── Filas y columnas ── -->
        <div class="accordion-header" (click)="activeResize=!activeResize">
            <div class="d-flex align-items-center" style="gap:8px">
                <i class="fa-light fa-table-cells"></i>
                <p class="m-0">Filas y columnas</p>
            </div>
            <i class="fa-light" [class.fa-chevron-down]="!activeResize"
                [class.fa-chevron-up]="activeResize"></i>
        </div>
        <div class="accordion-body" *ngIf="activeResize">
            <p class="info-hint">
                Añade o quita filas y columnas. Las butacas nuevas se crean visibles con el color del nivel; las existentes conservan su configuración.
            </p>
            <div class="field-group">
                <label class="field-label">Filas</label>
                <input class="field-input field-input--sm" type="number" min="1" [(ngModel)]="numRows" (change)="applyRowsChange()">
            </div>
            <div class="field-group">
                <label class="field-label">Columnas</label>
                <input class="field-input field-input--sm" type="number" min="1" [(ngModel)]="numCols" (change)="applyColsChange()">
            </div>
        </div>

        <!-- ── Cambiar butacas ── -->
        <div class="accordion-header" (click)="activeEditingSeats=!activeEditingSeats">
            <div class="d-flex align-items-center" style="gap:8px">
                <i class="fa-light fa-chair"></i>
                <p class="m-0">Cambiar butacas</p>
            </div>
            <i class="fa-light" [class.fa-chevron-down]="!activeEditingSeats"
                [class.fa-chevron-up]="activeEditingSeats"></i>
        </div>
        <div class="accordion-body" *ngIf="activeEditingSeats">
            <div class="check-row d-flex align-items-center justify-content-between">
                <p class="m-0">Numeración par</p>
                <mat-checkbox [(ngModel)]="numeracionPar" class="checkbox" color="primary"
                    (change)="changeNumPar()"></mat-checkbox>
            </div>
            <div class="check-row d-flex align-items-center justify-content-between">
                <p class="m-0">Numeración impar</p>
                <mat-checkbox [(ngModel)]="numeracionImpar" class="checkbox" color="primary"
                    (change)="changeNumImpar()"></mat-checkbox>
            </div>
            <div class="check-row d-flex align-items-center justify-content-between">
                <p class="m-0">De izquierda a derecha</p>
                <mat-checkbox [(ngModel)]="directionRight" class="checkbox" color="primary"
                    (change)="changeDirection()"></mat-checkbox>
            </div>
            <div class="field-group">
                <label class="field-label">Butaca de inicio</label>
                <input class="field-input field-input--sm" type="number" min="1" placeholder="1" [(ngModel)]="startSeat" (change)="editStartSeat()" required>
            </div>
            <div class="field-group">
                <label class="field-label">Butaca de inicio por fila</label>
                <select class="field-input" [(ngModel)]="selectedRowForStart" (change)="onRowForStartSelected()">
                    <option [ngValue]="null" disabled>Selecciona una fila</option>
                    <option *ngFor="let row of rowLabels" [ngValue]="row">
                        Fila {{row}}{{ rowStartSeatOverrides[row] != null ? ' (personalizado)' : '' }}
                    </option>
                </select>
            </div>
            <div class="field-group" *ngIf="selectedRowForStart != null">
                <label class="field-label">Butaca de inicio de la fila {{selectedRowForStart}}</label>
                <div class="d-flex align-items-center" style="gap:8px">
                    <input class="field-input field-input--sm" type="number" min="1"
                        [(ngModel)]="rowStartSeatValue" (change)="applyRowStartSeat()">
                    <button type="button" class="btn-edit-hidden"
                        [disabled]="rowStartSeatOverrides[selectedRowForStart] == null"
                        (click)="clearRowStartSeatOverride()">
                        <i class="fa-light fa-rotate-left"></i>
                        Quitar personalización
                    </button>
                </div>
            </div>
            <div class="field-range">
                <div class="field-range__head">
                    <label class="field-label">Rotación del número de butaca</label>
                    <span class="field-range__value">
                        <input type="number" min="-180" max="180" step="1" [(ngModel)]="seatNumberAngle" (input)="editSeatNumberAngle()">
                        <span class="field-range__unit">°</span>
                    </span>
                </div>
                <input type="range" min="-180" max="180" step="1" [(ngModel)]="seatNumberAngle" (input)="editSeatNumberAngle()" class="slider-rotation">
            </div>
        </div>

        <!-- ── Leyenda de filas ── -->
        <div class="accordion-header" (click)="activeEditingRows=!activeEditingRows">
            <div class="d-flex align-items-center" style="gap:8px">
                <i class="fa-light fa-list-ol"></i>
                <p class="m-0">Leyenda de filas</p>
            </div>
            <i class="fa-light" [class.fa-chevron-down]="!activeEditingRows"
                [class.fa-chevron-up]="activeEditingRows"></i>
        </div>
        <div class="accordion-body" *ngIf="activeEditingRows">
            <div class="field-group">
                <label class="field-label">Fila de inicio</label>
                <input class="field-input field-input--sm" type="number" min="1" placeholder="1" [(ngModel)]="startRow" (change)="editStartRow()" required>
            </div>
            <div class="check-row d-flex align-items-center justify-content-between">
                <p class="m-0">Invertir orden de filas (X → 1)</p>
                <mat-checkbox [(ngModel)]="reverseRows" class="checkbox" color="primary"
                    (change)="changeReverseRows()"></mat-checkbox>
            </div>
            <div class="field-range">
                <div class="field-range__head">
                    <label class="field-label">Rotación de números de fila</label>
                    <span class="field-range__value">
                        <input type="number" min="-180" max="180" step="1" [(ngModel)]="numberAngle" (input)="editNumberAngle()">
                        <span class="field-range__unit">°</span>
                    </span>
                </div>
                <input type="range" min="-180" max="180" step="1" [(ngModel)]="numberAngle" (input)="editNumberAngle()" class="slider-rotation">
            </div>
            <div class="check-row d-flex align-items-center justify-content-between">
                <p class="m-0">Mostrar filas (izquierda)</p>
                <mat-checkbox [(ngModel)]="legendLeft" class="checkbox" color="primary"
                    (change)="changeVisibilityRows('left')"></mat-checkbox>
            </div>
            <div class="check-row d-flex align-items-center justify-content-between">
                <p class="m-0">Mostrar filas (derecha)</p>
                <mat-checkbox [(ngModel)]="legendRight" class="checkbox" color="primary"
                    (change)="changeVisibilityRows('right')"></mat-checkbox>
            </div>
            <div class="check-row d-flex align-items-center justify-content-between">
                <p class="m-0">Mostrar fila en la entrada</p>
                <mat-checkbox [(ngModel)]="showRowOnTicket" class="checkbox" color="primary"
                    (change)="persistTicketLabelFlags()"></mat-checkbox>
            </div>
            <div class="check-row d-flex align-items-center justify-content-between">
                <p class="m-0">Mostrar la palabra «Butaca» en la entrada</p>
                <mat-checkbox [(ngModel)]="showSeatLabelOnTicket" class="checkbox" color="primary"
                    (change)="persistTicketLabelFlags()"></mat-checkbox>
            </div>
            <p class="info-hint">
                Con los dos activos la entrada dirá «Platea, Fila: 1, Butaca: 12».
                Sin la fila, «Platea, Butaca: 12». Sin ninguno de los dos, «Platea 12»
                — que es lo que interesa cuando la sección son mesas, palcos o plazas y
                la fila solo sirve para dibujar el plano.
                <br><br>
                Si desactivas la fila, asegúrate de que los números no se repiten entre
                filas (usa «Butaca de inicio por fila» para encadenarlos: 1…20, luego
                21…40), o habrá dos «Platea 12» indistinguibles.
            </p>
        </div>

        <!-- ── Butacas especiales ── -->
        <div class="accordion-header" (click)="toggleSpecialSeatsPanel()">
            <div class="d-flex align-items-center" style="gap:8px">
                <i class="fa-light fa-star"></i>
                <p class="m-0">Butacas especiales</p>
            </div>
            <i class="fa-light" [class.fa-chevron-down]="!activeSpecialSeats"
                [class.fa-chevron-up]="activeSpecialSeats"></i>
        </div>
        <div class="accordion-body" *ngIf="activeSpecialSeats">
            <ng-container *ngIf="!selectingSpecialMode">
                <p class="info-hint">
                    Asigna un nivel diferente a butacas individuales dentro de esta sección. La butaca adoptará el color del nivel seleccionado.
                </p>
                <div class="field-group">
                    <label class="field-label">Nivel para las butacas especiales</label>
                    <select class="field-input" [(ngModel)]="specialSeatLevel" [compareWith]="compareLevels">
                        <option [ngValue]="null" disabled>Selecciona un nivel</option>
                        <option *ngFor="let nivel of levels" [ngValue]="nivel">{{ nivel.name || 'Nivel ' + nivel.id }}</option>
                    </select>
                </div>
                <button class="btn-edit-hidden" (click)="activateSpecialSeatsMode()" [disabled]="!specialSeatLevel">
                    <i class="fa-light fa-pen"></i>
                    Seleccionar butacas
                </button>
            </ng-container>

            <ng-container *ngIf="selectingSpecialMode">
                <p class="info-hint">Haz clic en una butaca para asignarla al nivel <strong>{{specialSeatLevel?.name}}</strong>. Vuelve a hacer clic para desasignarla.</p>
                <div class="btns-save-apply">
                    <div class="section-option w-100" (click)="cancelSpecialSeatsMode()">
                        <p class="m-0">Cancelar</p>
                        <i class="fa-light fa-ban"></i>
                    </div>
                </div>
            </ng-container>
        </div>

        <!-- ── Asientos ocultos ── -->
        <div class="accordion-header" (click)="toggleHiddenSeatsPanel()">
            <div class="d-flex align-items-center" style="gap:8px">
                <i class="fa-light fa-eye-slash"></i>
                <p class="m-0">Asientos ocultos</p>
            </div>
            <i class="fa-light" [class.fa-chevron-down]="!activeHiddenSeats"
                [class.fa-chevron-up]="activeHiddenSeats"></i>
        </div>
        <div class="accordion-body" *ngIf="activeHiddenSeats">
            <ng-container *ngIf="!selectingInvisibleMode">
                <div class="stat-row">
                    <p class="m-0">Asientos ocultos</p>
                    <span class="stat-badge">{{invisibleSeats.length}}</span>
                </div>
                <div class="check-row d-flex align-items-center justify-content-between" *ngIf="invisibleSeats.length > 0">
                    <p class="m-0">Mostrar ocultos en el mapa</p>
                    <mat-checkbox [(ngModel)]="mostrarOcultos" class="checkbox" color="primary"
                        (change)="changeMostrarOcultos()"></mat-checkbox>
                </div>
                <button class="btn-edit-hidden" (click)="selectInvisibleSeats()">
                    <i class="fa-light fa-pen"></i>
                    Editar asientos ocultos
                </button>
            </ng-container>

            <ng-container *ngIf="selectingInvisibleMode">
                <p class="info-hint">Haz clic en los asientos para ocultarlos o mostrarlos.</p>
                <div class="btns-save-apply">
                    <div class="section-option w-100" (click)="cancelEdit()">
                        <p class="m-0">Cancelar</p>
                        <i class="fa-light fa-ban"></i>
                    </div>
                    <div class="section-option w-100" (click)="applyHiddenChanges()">
                        <p class="m-0">Guardar</p>
                        <i class="fa-light fa-floppy-disk"></i>
                    </div>
                </div>
            </ng-container>
        </div>

    </div>
</div>
